import { render, staticRenderFns } from "./MailTemplateDetailEntry.vue?vue&type=template&id=41fc9f57&scoped=true"
import script from "./MailTemplateDetailEntry.vue?vue&type=script&lang=ts"
export * from "./MailTemplateDetailEntry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fc9f57",
  null
  
)

export default component.exports